@let currentQuestion = question();
@if (currentQuestion && !showExplanation) {
  @switch (currentQuestion.type) {
    @case ("budget") {
      <div class="question-wrapper" [class.timedOut]="timedOut">
        <div class="question">
          <h2 class="question__heading">{{ currentQuestion.label }}</h2>
        </div>
        <div class="currency-wrapper">
          <app-currency-input
            [questionLength]="3"
            [answers]="currentQuestion.answers"
            (valueSubmit)="onAnswerClicked($event)"
          />
        </div>

        @if (!timedOut) {
          <div
            class="question__timer"
            [class.timedOut]="timedOut"
            [style.--question-timer]="currentQuestion.questionTime + 's'"
            (animationend)="timedOut = true"
          ></div>
        }
      </div>
    }
    @case ("open") {
      <app-explanation [explanation]="currentQuestion.label" (explanationSubmit)="onExplanationSubmit($event)" />
    }
    @default {
      <div class="question-wrapper" [class.timedOut]="timedOut">
        <div class="question">
          <h2 class="question__heading">{{ currentQuestion.label }}</h2>
        </div>
        <div class="answer-wrapper">
          @for (answer of currentQuestion?.answers; track answer) {
            <button class="answer-btn" (click)="onAnswerClicked(answer)">
              <span class="answer-btn__text">{{ answer.label }}</span>
            </button>
          }
        </div>
        @if (!timedOut) {
          <div
            class="question__timer"
            [class.timedOut]="timedOut"
            [style.--question-timer]="currentQuestion.questionTime + 's'"
            (animationend)="timedOut = true"
          ></div>
        }
      </div>
    }
  }
} @else {
  @if (showExplanation) {
    <app-explanation
      [explanation]="$safeNavigationMigration(givenAnswer?.answer?.explanation)"
      (explanationSubmit)="onExplanationSubmit($event)"
    />
  }
}
